import { z } from 'zod';

export const LocalDateTimeSchema = z
  .union([z.string(), z.tuple([z.number(), z.number(), z.number()]).rest(z.number())])
  .transform((value) => {
    if (typeof value === 'string') return value;
    const [y, mo, d, h = 0, mi = 0, s = 0] = value;
    const date = new Date(y, mo - 1, d, h, mi, s);
    return Number.isNaN(date.getTime()) ? '' : date.toISOString();
  })
  .describe('LocalDateTimeSchema');
